import { handleActions } from 'redux-actions';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { combineReducers } from 'redux';
import { products as productsAPI } from 'api';
import { getEntities } from 'selectors';
import { products } from 'schemas';
import { getProductsListApiHOC } from '../selectors';
import { types } from './actions';

export const getIsFetching = state => getProductsListApiHOC(state).isFetching;

export const getProducts = createSelector(
  state => getProductsListApiHOC(state).result,
  state => getEntities(state),

  (result, entities) => denormalize(
    result,
    products.arrayOfProductSchemas,
    entities,
  ),
);

export default combineReducers({
  isFetching: handleActions({
    [productsAPI.types.GET_PRODUCTS_REQUEST]: () => true,
    [productsAPI.types.GET_PRODUCTS_SUCCESS]: () => false,
    [productsAPI.types.GET_PRODUCTS_FAILURE]: () => false,
  }, false),

  result: handleActions({
    [productsAPI.types.GET_PRODUCTS_SUCCESS]: (state, { payload: { result } }) => result,
    [types.PRODUCTS_LIST_API_HOC_RESET]: () => null,
  }, []),
});



// WEBPACK FOOTER //
// ./src/components/apiHOCs/ProductsListApiHOC/reducers.js